export function dateNow(): number {
  return Date.now();
}
